// extracted by mini-css-extract-plugin
module.exports = {"link-text":"HowRoyalyWorksModal_link-text__1VYlo","button":"HowRoyalyWorksModal_button__24opR"};